
export const status = [{ id: 1, name: 'alive' }, { id: 2, name: 'dead' }, { id: 3, name: 'unknown' }];

export const species = [{ id: 1, name: 'human' }, { id: 2, name: 'alien' }, { id: 3, name: 'unknown' }];
